import React, { ReactNode } from "react";
import Icon from "~/assets/icons/Icon";
import { IconType } from "~/assets/icons/iconPaths";

type Props = {
  title: string;
  iconName: IconType;
  text: string | ReactNode;
};

export const EmptyStateMessage = ({ title, iconName, text }: Props) => {
  return (
    <div className="flex flex-col p-5 gap-5 md:flex-row items-center border-2 border-dashed rounded-lg border-secondary-300 md:max-w-max md:p-12 mx-auto mt-20 md:mt-40">
      <Icon name={iconName} className="w-[90px] text-secondary-300" />
      <div className="md:ml-7 md-max:text-center">
        <h3 className="text-3xl mb-2.5">{title}</h3>
        <p className="">{text}</p>
      </div>
    </div>
  );
};
